import { render, staticRenderFns } from "./ConnectDAPPDia.vue?vue&type=template&id=39f0dd3d&scoped=true"
import script from "./ConnectDAPPDia.vue?vue&type=script&lang=js"
export * from "./ConnectDAPPDia.vue?vue&type=script&lang=js"
import style0 from "./ConnectDAPPDia.vue?vue&type=style&index=0&id=39f0dd3d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0dd3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f0dd3d')) {
      api.createRecord('39f0dd3d', component.options)
    } else {
      api.reload('39f0dd3d', component.options)
    }
    module.hot.accept("./ConnectDAPPDia.vue?vue&type=template&id=39f0dd3d&scoped=true", function () {
      api.rerender('39f0dd3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/ConnectDAPPDia.vue"
export default component.exports